import React from 'react';

export default function IcMais() {
  return (
<svg width="14px" height="14px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	 viewBox="0 0 12 12">
<g>
	<g id="Combined-Shape">
		<path d="M11.9,6c0,0.3-0.3,0.6-0.6,0.6H6.6v4.8c0,0.3-0.3,0.6-0.6,0.6c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3-0.2-0.4V6.5
			l-4.8,0c-0.1,0-0.3-0.1-0.4-0.2C0.2,6.3,0.1,6.2,0.1,6c0-0.3,0.3-0.6,0.6-0.6h4.8V0.7c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6v4.8
			h4.8C11.7,5.4,11.9,5.7,11.9,6z"/>
	</g>
</g>
</svg>
  );
}
